import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Media from 'react-media'
import { getRouteProps } from 'react-static'
import { connect } from 'react-redux'
import { loadSlides } from '../actions'

import Home from '../components/home-page/Home'

class HomeContainer extends Component {
  static propTypes = {
    posts: PropTypes.array.isRequired,
    slides: PropTypes.array.isRequired,
    loaderHidden: PropTypes.bool.isRequired,
    numLoaded: PropTypes.number.isRequired,
  }

  state = { show: false }

  componentDidMount () {
    if (typeof window !== undefined) {
      this.setState({ show: true })
    }

    const { dispatch, slides, numLoaded } = this.props
    this.props.dispatch(loadSlides(slides, numLoaded))
  }

  render () {
    const { show } = this.state
    return (
      show && <Media query="(min-width: 801px)">
        { matches => (
          matches
            ? <Home headerHeight={66} {...this.props} />
            : <Home headerHeight={100} {...this.props} />
        ) }
      </Media>
    )
  }
}

const mapStateToProps = state => {
  const { loaderHidden } = state.loader
  const { numLoaded } = state.slides
  return { loaderHidden, numLoaded }
}

export default connect(mapStateToProps,
  dispatch => ({ dispatch }))(getRouteProps(HomeContainer))



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Home.js